(() => {
  'use strict';
  const KEY = 'xwitzeal.repair-profile.v1';
  const labels = {
    focus: {board:'Circuit board',screen:'Screen',battery:'Battery','back-glass':'Phone back cover'},
    series: {laser:'Laser series',cnc:'CNC series',separator:'Screen separator series',pressure:'Pressure holding series',debubbling:'Bubble removal series',heating:'Heating platform series',bench:'Auxiliary equipment',film:'Film cutting'},
    accessory: {sim:'SIM slots & trays',flex:'Flex cables',xwitzeal:'Xwitzeal machine parts',screwdrivers:'Precision screwdrivers','adhesive-scrapers':'Adhesive scrapers',tweezers:'Tweezers'},
    kind: {equipment:'Equipment',parts:'Parts & accessories'}
  };
  const cleanFocus = values => Object.keys(labels.focus).filter(value => Array.isArray(values) && values.includes(value));
  let memory = [];
  const readProfile = () => {
    try { const value = JSON.parse(localStorage.getItem(KEY)); return cleanFocus(value?.focus); }
    catch { return memory; }
  };
  function saveProfile(focus) {
    memory = cleanFocus(focus);
    try { localStorage.setItem(KEY, JSON.stringify({version:1,focus:memory})); } catch { /* URL still carries this visit's choices. */ }
    syncHeader(memory);
  }
  function focusFromURL(params, fallback) {
    return params.has('focus') ? cleanFocus(params.getAll('focus').flatMap(value => value.split(','))) : cleanFocus(fallback);
  }
  function syncHeader(focus) {
    document.querySelectorAll('[data-xz-profile-form] input[name="focus"]').forEach(input => { input.checked = focus.includes(input.value); });
    document.querySelectorAll('[data-xz-profile-count]').forEach(badge => { badge.textContent = focus.length; badge.hidden = !focus.length; });
    document.querySelectorAll('a[data-xz-catalog]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      url.searchParams.delete('focus'); url.searchParams.set('focus', focus.join(',') || 'all');
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      link.href = url.pathname + url.search;
    });
  }
  function navigateProfile(form, focus) {
    saveProfile(focus);
    const url = new URL(form.action, location.origin);
    url.searchParams.set('view','xz-finder'); url.searchParams.set('focus',focus.join(',') || 'all');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    location.assign(url.pathname + url.search);
  }
  function initHeader() {
    syncHeader(focusFromURL(new URLSearchParams(location.search), readProfile()));
    document.querySelectorAll('[data-xz-profile-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', event => { event.preventDefault(); navigateProfile(form, cleanFocus(new FormData(form).getAll('focus'))); });
      form.querySelector('[data-xz-clear-profile]').addEventListener('click', () => navigateProfile(form, []));
    });
  }
  function initFinder(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-xz-filter-form]');
    const grid = root.querySelector('[data-xz-product-grid]');
    let cards = [...grid.querySelectorAll('[data-xz-product]')];
    const search = root.querySelector('[data-xz-catalog-search]');
    const sort = root.querySelector('[data-xz-sort]');
    const chips = root.querySelector('[data-xz-active-filters]');
    let state;
    function loadURL() {
      const params = new URLSearchParams(location.search);
      state = { focus:focusFromURL(params,readProfile()),series:'',accessory:'',kind:'',query:params.get('model') || '',sort:'featured' };
      ['series','accessory','kind'].forEach(key => { const value=params.get(key); state[key]=Object.hasOwn(labels[key],value)?value:''; });
      if (state.accessory) { state.series=''; state.kind='parts'; }
      else if (state.series) state.kind='equipment';
      const order=params.get('sort');
      if (['featured','price-asc','price-desc','title'].includes(order)) state.sort=order;
      render();
    }
    function updateURL() {
      const url=new URL(location.href);
      url.searchParams.set('focus', state.focus.join(',') || 'all');
      ['series','accessory','kind'].forEach(key => { if(state[key])url.searchParams.set(key,state[key]);else url.searchParams.delete(key); });
      if(state.query)url.searchParams.set('model',state.query);else url.searchParams.delete('model');
      if(state.sort!=='featured')url.searchParams.set('sort',state.sort);else url.searchParams.delete('sort');
      history.replaceState(null,'',url.pathname+url.search+url.hash);
    }
    function matches(card) {
      const tokens = key => (card.dataset[key] || '').split(/\s+/);
      return (!state.focus.length || state.focus.some(value=>tokens('focus').includes(value)))
        && (!state.kind || card.dataset.kind===state.kind)
        && (!state.series || tokens('series').includes(state.series))
        && (!state.accessory || tokens('accessory').includes(state.accessory))
        && (!state.query.trim() || card.dataset.title.toLowerCase().includes(state.query.trim().toLowerCase()));
    }
    function chip(key,value,label) {
      const button=document.createElement('button');button.type='button';button.textContent=label+' ×';button.setAttribute('aria-label','Remove '+label+' filter');
      button.addEventListener('click',()=>{
        if(key==='focus') {state.focus=state.focus.filter(item=>item!==value);saveProfile(state.focus);}
        else {state[key]='';if(key==='kind'){state.series='';state.accessory='';}}
        render();updateURL();
      });chips.append(button);
    }
    function render() {
      form.querySelectorAll('input[name="focus"]').forEach(input=>{input.checked=state.focus.includes(input.value);});
      ['kind','series','accessory'].forEach(key=>{form.elements.namedItem(key).value=state[key];});
      search.value=state.query;sort.value=state.sort;
      syncHeader(state.focus);
      root.querySelector('[data-xz-profile-summary]').textContent=state.focus.length?'Your repair profile: '+state.focus.map(value=>labels.focus[value]).join(' + '):'All repair directions';
      root.querySelector('[data-xz-results-title]').textContent=labels.accessory[state.accessory] || labels.series[state.series] || labels.kind[state.kind] || 'Equipment & parts';
      let visible=0;
      const sorted=[...cards];
      if(state.sort==='price-asc')sorted.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
      if(state.sort==='price-desc')sorted.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
      if(state.sort==='title')sorted.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
      sorted.forEach(card=>{card.hidden=!matches(card);if(!card.hidden)visible++;grid.append(card);});
      root.querySelector('[data-xz-result-count]').textContent=visible+' '+(visible===1?'product':'products')+' for your setup';
      chips.replaceChildren();
      state.focus.forEach(value=>chip('focus',value,labels.focus[value]));
      ['kind','series','accessory'].forEach(key=>{if(state[key])chip(key,state[key],labels[key][state[key]]);});
      const note=root.querySelector('[data-xz-catalog-note]');
      note.hidden=!['sim','flex'].includes(state.accessory);
      note.textContent=state.accessory==='sim'?'SIM trays, readers and flex cables are currently listed together. Open the product and choose the exact component and phone model.':'Flex cables and SIM components are currently listed in the same product. Open the product and choose the cable and phone model you need.';
      const empty=root.querySelector('[data-xz-empty]');empty.hidden=visible>0;
      const noDebubblers=state.series==='debubbling' && !cards.some(card=>card.dataset.series.split(/\s+/).includes('debubbling'));
      root.querySelector('[data-xz-empty-title]').textContent=noDebubblers?'Bubble removal machines are not listed yet.':'No products match this setup yet.';
      root.querySelector('[data-xz-empty-copy]').textContent=noDebubblers?'Contact our team for availability, or explore other equipment series.':'Try another direction, clear your search or remove a filter to explore more products.';
    }
    form.addEventListener('submit',event=>event.preventDefault());
    form.addEventListener('change',event=>{
      const key=event.target.name;
      if(key==='focus') {state.focus=cleanFocus(new FormData(form).getAll('focus'));saveProfile(state.focus);}
      else if(['kind','series','accessory'].includes(key)) {
        state[key]=event.target.value;
        if(key==='series' && state.series){state.accessory='';state.kind='equipment';}
        if(key==='accessory' && state.accessory){state.series='';state.kind='parts';}
        if(key==='kind'){if(state.kind!=='equipment')state.series='';if(state.kind!=='parts')state.accessory='';}
      }
      render();updateURL();
    });
    search.addEventListener('input',()=>{state.query=search.value;render();updateURL();});
    sort.addEventListener('change',()=>{state.sort=sort.value;render();updateURL();});
    root.querySelectorAll('[data-xz-reset]').forEach(button=>button.addEventListener('click',()=>{state={focus:[],kind:'',series:'',accessory:'',query:'',sort:'featured'};saveProfile([]);render();updateURL();}));
    window.addEventListener('popstate',loadURL);
    root.addEventListener('xz:catalog-updated',()=>{
      cards=[...grid.querySelectorAll('[data-xz-product]')];
      render();
    });
    loadURL();
    const drawer=root.querySelector('.xz-filter-drawer');
    if(matchMedia('(max-width:749px)').matches && (state.focus.length || state.series || state.accessory))drawer.open=false;
  }
  function init() { initHeader();document.querySelectorAll('[data-xz-finder]').forEach(initFinder); }
  document.addEventListener('toggle',event=>{
    if(event.target.tagName!=='DETAILS'||!event.target.open||!event.target.closest('.xz-header'))return;
    document.querySelectorAll('.xz-header details[open]').forEach(details=>{if(details!==event.target)details.open=false;});
  },true);
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',init);
  init();
})();
